import { formatLocalYmd } from '../infra/salesDateRange';
import type { ReportsVentasProductScope } from '../../reports/domain/reportsTypes';
import type { ReportsQueryScope } from '../../reports/domain/reportsQueryScope';
import type { SalesListRouteParams, SalesListReportsScopeParams } from './salesNavigation';
import type { BranchSalesHistoryCashierFilter } from './salesNavigation';
export type { BranchSalesHistoryCashierFilter };

export type SalesListRouteDerivedState = {
  fromYmd: string;
  toYmd: string;
  search: string;
  cashierFilter: BranchSalesHistoryCashierFilter;
  paymentPendingOnly: boolean;
  reportsScope?: SalesListReportsScopeParams;
};

function resolveInitialDates(params?: SalesListRouteParams): { fromYmd: string; toYmd: string } {
  const ymd = formatLocalYmd(new Date());
  return {
    fromYmd: params?.fromYmd?.trim() || ymd,
    toYmd: params?.toYmd?.trim() || ymd,
  };
}

function parseReportsScopeItemType(
  raw: string | null | undefined
): ReportsVentasProductScope['itemType'] {
  if (raw === 'physical' || raw === 'service') return raw;
  return 'all';
}

/** Convierte estado de ruta SalesList al alcance canónico de Informes. */
export function salesListRouteStateToReportsQueryScope(
  state: SalesListRouteDerivedState
): ReportsQueryScope {
  const rs = state.reportsScope;
  return {
    categoryId: rs?.categoryId ?? null,
    itemType: parseReportsScopeItemType(rs?.itemType),
    search: state.search?.trim() ? state.search.trim() : null,
    productId: rs?.productId ?? null,
    brandId: rs?.brandId ?? null,
    supplierId: rs?.supplierId ?? null,
    customerId: rs?.customerId ?? null,
    cashierUserId: state.cashierFilter === 'all' ? null : state.cashierFilter,
  };
}

/** Deriva estado de filtros del listado desde params de navegación (Informes, deep links). */
export function resolveSalesListStateFromRouteParams(
  params?: SalesListRouteParams
): SalesListRouteDerivedState {
  const dates = resolveInitialDates(params);
  return {
    fromYmd: dates.fromYmd,
    toYmd: dates.toYmd,
    search: params?.search ?? '',
    cashierFilter: params?.cashierFilter ?? 'all',
    paymentPendingOnly: params?.paymentPendingOnly === true,
    reportsScope: params?.reportsScope,
  };
}
